import { useState, useEffect } from 'react'
import cutileiApi from 'services/cutileiApi'
import TextInput from 'components/Inputs/TextInput'
import NumberInput from 'components/Inputs/NumberInput'
import MainButton from 'components/Buttons/MainButton'
import { IoArrowForwardOutline } from 'react-icons/io5'
import { Formik } from 'formik'

import {
  Form,
  Label,
  SubTitle,
  InfoText,
  MoneyText,
  WarningText,
  FormField
} from '../styles'

export default function MembersForm ({
  subscriptionData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const { discount } = subscriptionData

  return (
    <Formik
      initialValues={{
        'num_users': subscriptionData.num_users || 1,
        'promo_code': subscriptionData.promo_code || ''
      }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          setErrorMessage (null)
          const { promo_code } = values

          await cutileiApi.post ('/promo_codes/verify_existing', { promo_code })

          setSubmitting (false)
          handleFormSubmitted (values)
        } catch (error) {
          setSubmitting (false)
          setErrorMessage (
            error.response?.data?.message ||
            'Ocorreu um erro ao verificar o código promocional.'
          )
        }
      }}
    >
      {function MembersForm ({
        values,
        isSubmitting,
        setFieldValue,
        handleBlur,
        handleSubmit
      }) {
        useEffect (() => {
          setErrorMessage (null)
        } , [values.promo_code])

        return (
          <Form onSubmit={handleSubmit} style={{ width: 420 }}>
            <SubTitle>Escolha o número de colaboradores</SubTitle>
            <InfoText>
              Para cada colaborador adicionado, será gerado um cupom promocional que dará o desconto corporativo na sua assinatura.
            </InfoText>
            <FormField>
              <Label>Número de colaboradores</Label>
              <NumberInput
                name='num_users'
                placeholder='Número de colaboradores'
                minValue={1}
                maxValue={20}
                value={values.num_users}
                onChange={setFieldValue}
                onBlur={handleBlur}
                style={{width: 200}}
              />
            </FormField>
            <FormField>
              <Label>Cupom promocional</Label>
              <TextInput
                name='promo_code'
                placeholder='Código'
                value={values.promo_code}
                onChange={e => setFieldValue ('promo_code', e.target.value.toUpperCase ())}
                onBlur={handleBlur}
              />
              {errorMessage && (
                <WarningText>{errorMessage}</WarningText>
              )}
            </FormField>
            <InfoText>
              Valor total:&ensp;
              <MoneyText value={discount * values.num_users}/>
            </InfoText>
            <MainButton
              onClick={handleSubmit}
              aria-label='Próximo'
              leftIcon={<IoArrowForwardOutline size={20} color='#000000'/>}
              disabled={isSubmitting}
              loading={isSubmitting}
              style={{width: 55}}
            />
          </Form>
        )
      }}
    </Formik>
  )
}
